import type { IProyectoNBS } from '../../../modelos/CotizadorNBS/entidades/IProyectoNBS';
import type { IAdministracionObra } from '../../../modelos/CotizadorNBS/entidades/IAdministracionObra';
import type { ICotizacionNBS } from '../../../modelos/CotizadorNBS/entidades/ICotizacionNBS';

export const estadoInicialProyectoNBS: IProyectoNBS = {
    NombreCliente: '',
    Nombre: '',
    Ciudad: '',
    OtrasCiudades: false,
    Anio: new Date().getFullYear(),
    MesesContrato: 0,
    // Por defecto 3 meses de mantenimiento gratis (definido con el cliente); el usuario lo puede cambiar.
    MesesMantenimiento: 3,
    AplicaPolizas: true,
    PlazoEntregaMeses: null,
    MesesInstalacion: null,
    GarantiaFabricacionMeses: null,
    GarantiaInstalacionMeses: null,
    Trm: 0,
};

/** Id de Panamá en el catálogo de países (el mismo del back). Panamá y Costa Rica tienen la misma moneda. */
export const PAIS_PANAMA_ID = 2;

/** Plazos de la Oferta Comercial que se pueden elegir en el paso 1 (documento de requerimientos del cliente, 2026-10-15). */
export const OPCIONES_PLAZO_ENTREGA_MESES = [6, 7, 8, 9, 10, 11, 12, 18, 24];
export const OPCIONES_PLAZO_INSTALACION_MESES = [2, 3, 4, 5, 6, 7, 8];

/** Meses de mantenimiento a costo que se pueden elegir (cliente, 2026-10-15). */
export const OPCIONES_MESES_MANTENIMIENTO = [3, 6, 9, 12];

/**
 * Uno de la lista, o más de 12 si el usuario tiene PERMISO_COTIZADOR_NBS_MANTENIMIENTO_EXTENDIDO.
 * El back acepta más de 12 sin verificar el permiso (no recibe los permisos del usuario).
 */
export const mesesMantenimientoValidos = (meses: number, puedeExtender: boolean) =>
    OPCIONES_MESES_MANTENIMIENTO.includes(meses)
    || (puedeExtender && Number.isInteger(meses) && meses > OPCIONES_MESES_MANTENIMIENTO[OPCIONES_MESES_MANTENIMIENTO.length - 1]);

export const estadoInicialAdminObra: IAdministracionObra = {
    ProfesionalSST: 0,
    IngResidente: 0,
    DirectorObra: 0,
    SupervisorMontaje: 0,
    ProfesionalElectricoRETIE: 0,
    AseoObra: 0,
    OficinaBIM: 0,
    SoporteKONEMX: 0,
};

export const estadoInicialCotizacionNBS: ICotizacionNBS = {
    FechaCreacion: new Date().toISOString(),
    Proyecto: estadoInicialProyectoNBS,
    AdministracionObra: estadoInicialAdminObra,
    Ascensores: [],
    Escaleras: [],
};

export const estadoInicialCotizacion: import('../../../modelos/CotizadorNBS/entidades/ICotizacion').ICotizacion = {
    Id: 0,
    IdSolicitud: 0,
    CodigoServicio: 0,
    FechaCreacion: '',
    TecnicoSolicita: '',
    Repuesto: '',
    Cantidad: 0,
    PrecioVenta: 0,
    FechaAprobacion: null,
    Aprobada: false,
    Eliminado: false,
    CreadoUtc: '',
    ActualizadoUtc: '',
};

export interface IFiltroCotizacionesVistaProps {
  consultarCotizaciones: () => void;
  filtro: any;
  manejarCambioFiltroCotizacion: (campo: string, valor: any) => void;
}

export interface ITablaCotizacionesVistaProps {
  tabla: any;
  consultarCotizaciones: () => void;
  filtro: any;
  manejarCambioFiltroCotizacion: (campo: string, valor: any) => void;
  habilitarFiltros: boolean;
  manejarHabilitarFiltros: () => void;
}
